import { LitElement, html, svg } from 'lit';

export class IconMail32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Konvolutt</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M28 5.333H4a2 2 0 0 0-2 2v17.334a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V7.333a2 2 0 0 0-2-2Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2.667 6 10.644 9.019a4.411 4.411 0 0 0 5.379 0L29.1 6.197"></path></svg>`; }
}
if (!customElements.get('f-icon-mail32', IconMail32)) {
  customElements.define('f-icon-mail32', IconMail32);
}